import { Node as SlateNode, Transforms as SlateTransforms } from 'slate';

import { SLATE_PROMPT_TAGS, SLATE_TEXT_FORMATS } from 'src/lib/slate';

export const withPromptTags = (editor) => {
  const { normalizeNode, isVoid } = editor;

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    // handle empty "prompt tags" and remove them
    if (SLATE_PROMPT_TAGS.includes(node.type)) {
      if (!SlateNode.string(node).trim()) {
        SlateTransforms.unwrapNodes(editor, { at: path });
      }
    }

    normalizeNode(entry);
  };

  // "instruction" elements should be treated as voids
  editor.isVoid = (element) => {
    if (element.type === SLATE_TEXT_FORMATS.PROMPT_INSTRUCTION) {
      return true;
    }

    return isVoid(element);
  };

  return editor;
};
